import { v1 } from './v1';

export const search = {
  v1,
};
